module.exports = __webpack_public_path__ + "static/media/hpm-image-v4.462c8d5f.jpeg";